import { InformacionFamiliarData } from 'components/InformacionFamiliar'
import { GlobalFilter } from 'components/UsuarioGeneral/Solicitud Certificados/GlobalFilter'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions'
import { getTdTableStyles } from 'helpers/Table/tableFunctions'
import React, { useMemo } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable, useRowSelect, Column, UseFiltersOptions } from 'react-table'
import { Table, Button, Col, Row } from 'reactstrap'
import { InformacionTablaSustitutoFamiliar } from './TypesSustitutoFamiliar'


type PropsTablaHistorialSustituto = {
    datos: InformacionTablaSustitutoFamiliar[],
    onClickVerDocumento: (refArchivo: string) => Promise<void>,
    titulo: string,
    onActivarModal: (informacionFamiliarEnModal: InformacionFamiliarData | undefined,editarInformacionSustituto?:InformacionTablaSustitutoFamiliar) => void
    FinalizacionAnticipada : (idAsociado:number,nombreTabla:string) => Promise<void>
    informacionFamiliar:InformacionFamiliarData[]
}



export default function TablaHistorialSustitutoFamiliar(prop: PropsTablaHistorialSustituto) {

    const filas = useMemo(() => [...prop.datos], [prop.datos])



    function GetComponenteVerDocumentoPDF(referencia: string) {
        var referenciaNoEsValidad = referencia === null || referencia === undefined || referencia === ""
        if (!referenciaNoEsValidad) {
            return (
                <Button style={{ backgroundColor: "#FFC200", float: "none", height: "27px", width: "27px" }} className="m-0 p-1 btn-icono" onClick={async () => await prop.onClickVerDocumento(referencia)}>
                    <i className="fas fa-eye" aria-hidden="true" ></i>
                </Button>
            )
        }
        else {
            return (<div></div>)
        }


    }


    function GetComponenteAcciones(valor: InformacionTablaSustitutoFamiliar) {
        if (valor && (valor.estado === "INGRESADA" || valor.estado === "RECHAZADA")) {
            const informacionUsada = prop.informacionFamiliar.find((c) => c.iddependientepersona == valor.idPersonaDependiente);
            return (

                <div data-toggle="tooltip" title="Editar"      >
                    <i className="fas fa-edit clickable iconTablaSustituto" aria-hidden="true" onClick={() => {prop.onActivarModal(informacionUsada,valor)}}   ></i>
                </div>
            )
        }
        else if (valor && valor.estado === "ACEPTADA" && valor.vigencia === "SI" && valor.tabla !== "TBL_DEPENDIENTE_PERSONA") {
            
            // const idAsociado = valor.idDatosSustitucionFamiliar
            // if(idAsociado !== undefined) {
            //     return (
            //         <div data-toggle="tooltip" title="Finalización Anticipada">
            //             <button className="btnEspolred">Finalizar Anticipadamente</button>
            //             <i className="fas fa-ban clickable iconTablaSustituto"   onClick={() => prop.FinalizacionAnticipada(idAsociado,valor.tabla) } ></i>
            //         </div>
            //     )
            // }
            return <div></div>
            
        }
        else {
            return <div></div>
        }
    }

    type typeColumna = Column<InformacionTablaSustitutoFamiliar> & UseFiltersOptions<InformacionTablaSustitutoFamiliar>

    const columnas = useMemo<readonly typeColumna[]>(() => [

        {
            Header: "Vigente",
            accessor: "vigencia",
        },
        {
            Header: "Estado",
            accessor: "estado",
        },
        {
            Header:"Observacion TH",
            accessor:"descripcionRevisionTH"
        },
        {
            Header: "Nombres",
            accessor: "nombresCompletos",
        },
        {
            Header: "Número Certificado",
            accessor: "nrocertificacion",
        },
        {
            Header: "Fecha Emisión",
            accessor: "fechaEmision",
            Cell: ({ value }) => <div>{ObtenerFechaFromIsoFormat(value?.toString())}</div>

        },
        {
            Header: "Fecha Caducidad",
            accessor: "fechaCaducidad",
            Cell: ({ value }) => <div>{ObtenerFechaFromIsoFormat(value?.toString())}</div>

        },
        {
            Header: "Fecha Ingreso",
            accessor: "fechaRegistro",
            Cell: ({ value }) => <div>{ObtenerFechaFromIsoFormat(value?.toString())}</div>
        },
        {
            Header: "Archivo",
            accessor: "refevidencia",
            Cell: ({ value }) => GetComponenteVerDocumentoPDF(value)
        },
        {
            Header: "Acciones",
            accessor: "acciones",
            Cell: ({ value }) => GetComponenteAcciones(value)

        }
    ]
        , [prop.datos])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        prepareRow,
        state,
        setGlobalFilter,
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination

    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;

    return (
        <React.Fragment>
            <Row className="mt-3">
                <Col xl={12} >
                    <div className='titleForTable'>{prop.titulo}</div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <GlobalFilter
                        filter={globalFilter}
                        setFilter={setGlobalFilter}
                    />
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="GeneralTable">
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' })

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>


                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}
